/**
 * Get the value of a cookie
 * Source: https://gist.github.com/wpsmith/6cf23551dd140fb72ae7
 * @param  {String} name  The name of the cookie
 * @return {String}       The cookie value
 */
function getCookie(name) {
  let value = `; ${document.cookie}`;
  let parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

export const toastNotification = () => {
  const bannerStatus = document.querySelector('.toast[data-status]');
  if (!bannerStatus) return;
  const toastStatus = getCookie('toast-notification');
  const body = document.querySelector('body');

  const hideBanner = () => {
    bannerStatus.dataset.status = 'hide';
    body.classList.remove('body--toast');
  };

  document.addEventListener('click', (e) => {
    console.log(e.target);
    if (e.target.closest('[data-toastclose]')) {
      document.cookie = `toast-notification=hide; path=/; max-age=${
        60 * 60 * 24 * 28
      };`;
      hideBanner();
    }
  });

  if (toastStatus === 'hide') {
    hideBanner();
  } else {
    bannerStatus.dataset.status = 'visible';
    body.classList.add('body--toast');
  }
};
